/**
 * Created by nijin on 23/6/17.
 */
import {Component, OnInit, Input, OnChanges, ViewChild} from '@angular/core';
import {GlobalService} from "../../../global/global.service";
import {NotificationBarService} from "../../../core/notify/notification.service";
import {NotificationType} from "../../../core/notify/index";
import {AppModalComponent} from "../../../shared/modal/modal";

@Component({
    selector: 'nuc-edit-location-tab',
    templateUrl: './location-edit.component.html',
  	styleUrls:['./location-edit.component.scss']
})
export class LocationEditComponent implements OnInit, OnChanges {
  public locationTypes: Array<any> = [];
  public locationDataType: Array<any> = [];
  public isPredefined :boolean = false;
  public locationType: string;
  public  predefined = 'predefined';
  public  custom = 'custom';

  private selectedLocation = [];

  @ViewChild('warning') warning: AppModalComponent;

  @Input() schema: any = {};
  @Input() isMobileApp: boolean;


  constructor(private globalService: GlobalService,
              private notifier: NotificationBarService) { }

    ngOnInit() {

       this.getLocationTypes();
       this.getLocationDataType();
    }

    ngOnChanges(){
      this.locationType = this.schema.predefinedLocation ? this.predefined : this.custom;
    }

    getLocationTypes(){
        this.globalService.getConfigDataByType(this.globalService.LOCATION_TYPES)
          .subscribe((location)=>{ this.locationTypes = location.items},
            (error)=>{this.notifier.create({type: NotificationType.Error, message:error})})
    }

  getLocationDataType(){
    this.globalService.getConfigDataByType(this.globalService.LOCATION_DATA_TYPE)
      .subscribe((response)=>{ this.locationDataType = response.items}, ()=>{})
  }

  confirmTypeChange(e: any, type?){
    if(this.isMobileApp){
      return true;
    }

    if(this.schema.predefinedLocation && type.value) {
      return true;
    }
    if(!this.schema.predefinedLocation && !type.value) {
      return true;
    }

     if(!this.schema.predefinedLocation){
       if(this.schema.location.length){
         this.warning.open();
         this.selectedLocation = type.value ? JSON.parse(type.value) : [];
         e.preventDefault();
       }
       else{
         this.locationType = this.predefined;
         this.schema.predefinedLocation = true;
         this.schema.location = type.value ? JSON.parse(type.value) : [];
       }
     }
      else{
       this.locationType = this.custom;
       this.schema.predefinedLocation = false;
       this.schema.location = type.value ? JSON.parse(type.value) : [];
     }

  }

  changeLocationType(event){
    this.schema.location = this.selectedLocation;
    this.locationType = this.predefined;
    this.schema.predefinedLocation = true;
  }

  cancelTypeChange(){

  }


}



// WEBPACK FOOTER //
// ./src/app/schema/edit-schema/location/location-edit.component.ts